module.exports = __webpack_public_path__ + "static/media/28.9e8f9ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/28.png
// module id = 988
// module chunks = 0